import { HttpClient } from 'helpers/http';

import { IHomeStatisticsService } from 'types/services/homeStatistics';

export class HomeStatisticsService implements IHomeStatisticsService {
  constructor(private client: HttpClient) {}

  API = {};
}
